import { AskableIconLoading } from '@askable/ui/core/askable-icon';

export const RoutePending = () => {
  return (
    <div className="flex flex-1 items-center justify-center p-6">
      <AskableIconLoading />
    </div>
  );
};
